<template>
  <v-container fluid class="px-8">
    <v-row>
      <v-col cols="4">
        <ValidationObserver v-slot="{ handleSubmit }">
          <v-form v-on:submit.prevent="handleSubmit(save)">
            <v-row>
              <v-col cols="12" class="pt-0">
                <v-radio-group
                  @change="getMajorByDegreeType"
                  class="mt-0"
                  v-model="form.degreeType"
                >
                  <v-row class="radio-group">
                    <v-col cols="6" class="px-0 py-0">
                      <v-radio
                        class="label"
                        label="De Bac à Bac+3"
                        :value="3"
                      ></v-radio>
                    </v-col>
                    <v-col cols="6" class="px-0 py-0">
                      <v-radio
                        class="label"
                        label="De Bac+3 à Bac+6"
                        :value="1"
                      ></v-radio>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
              <v-col cols="12" class="input-topic">
                <p class="label">Topic</p>
                <v-select
                  :disabled="!form.degreeType"
                  @change="getSpecialityByTopic"
                  v-model="form.major"
                  :items="topics"
                  item-value="id"
                  item-text="name"
                  hide-details
                  outlined
                  max-width="100%"
                  style="max-width: 100%"
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  rules="required"
                  name="Spécialité"
                  v-slot="{ errors }"
                >
                  <p class="label">Spécialité</p>
                  <v-select
                    :disabled="!form.major"
                    @change="setSpeciality"
                    v-model="form.speciality"
                    :items="specialities"
                    item-value="id"
                    item-text="name"
                    outlined
                    max-width="100%"
                    style="max-width: 100%"
                    :error-messages="errors"
                  >
                  </v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="mt--20">
                <v-row class="label-upload">
                  <v-col cols="6" class="font-weight-bold">
                    <span>Télécharger le fichier</span>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <span class="error--text"
                      >Type de fichier: *.docx, *.doc</span
                    >
                  </v-col>
                </v-row>
                <v-file-input
                  class="upload-resume"
                  id="upload-resume"
                  @change="setFile"
                  append-icon="fas fa-upload"
                  @click:append="openFileInput('upload-resume')"
                  placeholder="Sélectionnez un fichier"
                  outlined
                  accept=".doc,.docx"
                  prepend-icon
                />
              </v-col>
              <v-col
                      class="mt--20"
                cols="12"
                v-if="
                  (form.cvs || []).length > 0 || (form.files || []).length > 0
                "
              >
                <v-card class="files-upload">
                  <div class="py-2 px-2">
                    <p
                      class="py-1 mb-0"
                      v-for="(file, index) in form.cvs"
                      :key="index"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span
                            v-on="on"
                            class="cursor-pointer mr-1 error--text"
                            @click="removeFile('cvs', file)"
                          >
                            X
                          </span>
                        </template>
                        <span>Supprimer</span>
                      </v-tooltip>
                      <span
                        @click="downloadAs(file.id, file.name)"
                        class="file-upload cursor-pointer"
                        >{{ file.name }}</span
                      >
                    </p>
                    <p
                      class="py-1 mb-0"
                      v-for="(file, index) in form.files"
                      :key="index"
                    >
                      <span
                        class="pr-3 error--text"
                        @click="removeFile('files', file)"
                        >x</span
                      ><a href="#" class="file-upload">{{ file.name }}</a>
                    </p>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" class="mt--20 py-3">
                <v-btn
                  color="primary"
                  type="submit"
                  rounded
                  depressed
                  >Sauvegarder</v-btn>
                <v-btn
                  class="px-2 ml-3"
                  color="gray"
                  rounded
                  depressed
                  @click="cancel"
                  >Annuler</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import resumeService from "@/services/resume";
import majorService from "@/services/major";
import { mapState } from "vuex";
export default {
  name: "ResumeForm",
  props: {},
  data: () => ({
    file: null,
    reviewImage: "",
    topics: [],
    specialities: []
  }),
  computed: {
    ...mapState({
      form: state => state.resume.resume
    })
  },
  async created() {
    if (this.form.degreeType) {
      await this.getMajorByDegreeType(false);
    }
    if (this.form.major) {
      await this.getSpecialityByTopic(false);
    }
  },
  methods: {
    openFileInput(id) {
      let inputUpload = document.getElementById(id);
      if(inputUpload) {
        inputUpload.click();
      }
    },
    removeFile(field, file) {
      this.form[field] = this.form[field].filter(item => item !== file);
    },
    async getMajorByDegreeType(reset = true) {

      let res = await majorService.getMajorByDegreeType({
        degreeType: this.form.degreeType
      });
      if (res) {
        this.topics = res.data;
        this.specialities = [];
        if(reset) {
          this.form.major = null;
          this.form.speciality = null;
        }
      }
    },
    async getSpecialityByTopic(reset = true) {
      let res = await resumeService.getSpecialityByTopic({
        major: this.form.major
      });
      if (res) {
        this.specialities = res.data;
        if(reset) {
          this.form.speciality = null;
        }
      }
    },
    setSpeciality(speciality) {
      let find = this.specialities.find(({ id }) => speciality === id);
      if (find) {
        this.$store.dispatch("setResume", find);
      }
    },
    cancel() {
      this.$store.dispatch("resetNews");
      this.$router.push({
        name: "IndexResume",
        query: {
          tab: 0
        }
      });
    },
    setFile(file) {
      this.form.files.push(file);
    },
    async save() {
      let formData = new FormData();
      Object.keys(this.form).forEach(key => {
        if (Array.isArray(this.form[key])) {
          this.form[key].forEach((item, index) => {
            if (key === "files") {
              formData.append(`${key}[${index}]`, item);
            } else {
              formData.append(`${key}[${index}]`, item.id);
            }
          });
        } else {
          formData.append(key, this.form[key]);
        }
      });
      if (this.form.id) {
        let res = await resumeService.update(this.form.id, formData);
        if (res) {
          this.$router.push({
            name: "IndexResume",
            query: {
              tab: 0
            }
          });
        }
      }
    }
  }
};
</script>
<style lang="sass">
.files-upload
    box-shadow: none !important
    border: 1px solid #E1E1E1 !important
    box-sizing: border-box
    border-radius: 6px
    .file-upload
        color: #2F80ED !important
        text-decoration: none
.label-upload
    span
        font-size: 13px
.upload-resume
    .v-input__slot
        fieldset
            background: #E0E0E0
.input-topic
    margin-top: -15px
</style>
